import { FramedIcon } from '@heidi/design-system/framed-icon';
import { DialogDrawerHeader } from '@heidi/design-system/mobile-responsive-dialog-drawer';
import { SegmentedControl } from '@heidi/design-system/segmented-control';
import { TypographyH2, TypographyPBold } from '@heidi/design-system/typography';
import { FormattedMessage } from 'react-intl';
import { type Period } from '../../../../../contracts/types/commerce.types';
import { getCommerceBillingUiPorts } from '../../../../settings/billing/billing-ui-ports';
import { PeriodTabsList } from '../period-tabs-list';

interface ModalHeaderProps {
  period: Period;
  onPeriodChange: (period: Period) => void;
}

export function EndPromotedModalHeader({ period, onPeriodChange }: ModalHeaderProps) {
  return (
    <DialogDrawerHeader className="flex flex-col items-center gap-4">
      <FramedIcon state="pro" />
      <div>
        <TypographyH2 className="text-center">
          <FormattedMessage
            defaultMessage="Keep creating the best notes with Pro Scribe"
            id="Z2usM6vq1Q"
            description="Title of the modal shown when a promoted Pro Scribe trial ends"
          />
        </TypographyH2>
        <TypographyPBold className="text-center text-text-secondary">
          <FormattedMessage
            defaultMessage="Your free day of Pro Scribe is over, but Heidi Pro has even more to offer"
            id="1A4Fl2Zkqs"
            description="Subtitle of the modal shown when a promoted Pro Scribe trial ends"
          />
        </TypographyPBold>
      </div>
      {!getCommerceBillingUiPorts().isHideProMonthlyOption() && (
        <SegmentedControl
          value={period}
          onValueChange={(newTabState) => onPeriodChange(newTabState as Period)}
          className="items-center"
        >
          <PeriodTabsList />
        </SegmentedControl>
      )}
    </DialogDrawerHeader>
  );
}
